import Wrapper from "../components/Wrappers/Wrapper";
import NotFoundContainer from "../features/NotFound/NotFoundContainer";

const NotFound = () => {
  return (
    <Wrapper>
      <NotFoundContainer />
    </Wrapper>
  );
};

export default NotFound;
